import axios from 'axios'
import '@babel/polyfill'

const service = axios.create({
  // baseURL: `http://localhost:3000/api`
  baseURL: `/cms/api`,
})

export default service

let _projects = []
let _projectsmedia = []
let _category = 'all'
let _language = 'pt'

const getProjectsMedia = async () => {
  if (_projectsmedia.length === 0) {
    let projects = await service.get('tree/projetos?lang=pt')
    if (projects.data && projects.data.children.length > 0) {
      let sorted = projects.data.children.sort((a, b) => a.num - b.num)
      sorted.map(project => {
        if (!project.visible) return
        if (project.projectimages && project.projectimage != '') {
          let tokens = project.projectimages.replace(/- /g, '').split('\n')
          let parsed = []
          tokens.map(image => {
            let found = project.files
              .filter(e => e.url.split('/').pop() === image.trim())
              .pop()
            if (found) parsed.push(found)
          })
          project.projectimages = parsed
        } else {
          // to facilitate debug
          console.log('!...', project.id)
        }
        _projectsmedia.push(project)
      })
    }
    return _projectsmedia
  }
}

// export const getAllProjects = async search => {
//   if (search) _language = search === '?lang=en' ? 'en' : 'pt'
//   if (_projects.length === 0) {
//     try {
//       let projects = await service.get('tree/projetos?lang=' + _language)
//       if (projects.data && projects.data.children.length > 0) {
//         let sorted = projects.data.children.sort((a, b) => a.num - b.num)
//         let projectsmedia = await getProjectsMedia()
//         sorted.map((project, index) => {
//           if (!project.visible) return
//           if (project.projectimages && project.projectimage != '') {
//             project.projectimages = projectsmedia[index].projectimages
//           }

//           project.id = project.id.replace('projetos', 'projeto')

//           if (project.categories.indexOf(',') !== -1) {
//             project.categories = project.categories.split(',')
//           }

//           _projects.push(project)
//         })
//       }
//     } catch (error) {
//       console.log('error', error)
//     }
//   }
//   return _projects
// }

export const getAllProjects = async search => {
  if (search) _language = search === '?lang=en' ? 'en' : 'pt'
  if (_projects.length === 0) {
    try {
      let projects = await service.get('tree/projetos?lang=' + _language)
      if (projects.data && projects.data.children.length > 0) {
        let sorted = projects.data.children.sort((a, b) => a.num - b.num)

        sorted.map(project => {
          if (!project.visible) return
          if (project.projectimages && project.projectimage != '') {
            let tokens = project.projectimages.replace(/- /g, '').split('\n')
            let parsed = []
            tokens.map(image => {
              let found = project.files
                .filter(e => e.url.split('/').pop() === image.trim())
                .pop()
              if (found) parsed.push(found)
            })
            project.projectimages = parsed
          } else {
            // to facilitate debug
            console.log('!...', project.id)
          }

          project.id = project.id.replace('projetos', 'projeto')

          if (project.categories.indexOf(',') !== -1) {
            project.categories = project.categories.split(',')
          }

          _projects.push(project)
        })
      }
    } catch (error) {
      console.log('error', error)
    }
  }
  return _projects
}

export const setCategory = category => {
  _category = category
}

export const setLanguage = language => {
  _language = language
}

export const getProject = async (uri, search) => {
  try {
    let reload = false

    if (search === '?lang=en' && _language != 'en') {
      _language = 'en'
      reload = true
    } else if (search === '?lang=pt' && _language != 'pt') {
      _language = 'pt'
      reload = true
    }

    // the projects var are not setted
    // we need to take it first
    if (_projects.length === 0 || reload) {
      await getAllProjects()
    }

    // get current project in pt, to get the real images
    let count = _projects.length
    let next
    let previous
    let current

    // apply the category filter, so the next prev will be within the category
    let filtered = []

    _projects.map(e => filtered.push(e))

    if (_category !== 'all') {
      filtered = _projects.filter(project => {
        let found = false
        if (project.categories instanceof Array) {
          found =
            project.categories.filter(e => e.trim() === _category.filter)
              .length > 0
        } else {
          found = project.categories === _category.filter
        }
        return found
      })
    }

    filtered.map((project, index) => {
      if (project.uid.indexOf(uri.split('/').pop()) !== -1) {
        if (index - 1 >= 0) {
          previous = filtered[index - 1]
        }

        if (index + 1 < count) {
          next = filtered[index + 1]
        }

        current = project
      }
    })

    const result = {
      current,
      next,
      previous,
    }

    return result
  } catch (error) {
    console.log('error:', error)
  }
}

export const getIntroSlideshow = async lang => {
  let content = []
  try {
    let result = await service.get(`node/home`)
    content = result.data
    Object.keys(content).map(key => {
      if (key.indexOf('slideshow') !== -1) {
        let parsed = []
        let tokens = content[key].replace(/- /g, '').split('\n')

        tokens.map(token => {
          let item = content.files
            .filter(e => {
              let A = e.url.split('/').pop()
              let B = token.trim()
              return A === B
            })
            .pop()
          if (!item) return
          if (item.target)
            item.target = item.target.replace('projetos', '/projeto')
          else item.target = '/projetos'
          parsed.push({ url: item.target, image: item.url })
        })
        content[key] = parsed
      }
    })
  } catch (error) {
    console.log('error:', error)
  }
  return content
}

export const getPageContents = async (page, lang) => {
  try {
    let result = await service.get(`node/${page}${lang}`)
    let content = {}

    if (result.data) {
      content = result.data

      // parse slideshows
      Object.keys(content).map(key => {
        if (key.indexOf('slides') !== -1) {
          let parsed = []
          let tokens = content[key].replace(/- /g, '').split('\n')

          tokens.map(token => {
            let item = content.files
              .filter(e => {
                let A = e.url.split('/').pop()
                let B = token.trim()
                return A === B
              })
              .pop()
            parsed.push(item.url)
          })
          content[key] = parsed
        }
        if (key.indexOf('foto') !== -1) {
          let item = content.files
            .filter(e => {
              let A = e.url.split('/').pop()
              let B = content[key].trim()
              return A === B
            })
            .pop()
          if (item) content[key] = item.url
        }
      })
    }

    return content
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/components/api.js